import { ref } from 'vue'

export interface ConfirmDialogConfig {
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
}

interface ConfirmDialogState extends ConfirmDialogConfig {
  isOpen: boolean
  resolve?: (value: boolean) => void
}

const state = ref<ConfirmDialogState>({
  isOpen: false,
  title: '',
  description: '',
  confirmText: undefined,
  cancelText: undefined,
  resolve: undefined,
})

export function useConfirmDialog() {
  const showConfirm = (config: ConfirmDialogConfig): Promise<boolean> => {
    return new Promise((resolve) => {
      state.value = {
        isOpen: true,
        title: config.title || '',
        description: config.description || '',
        confirmText: config.confirmText,
        cancelText: config.cancelText,
        resolve,
      }
    })
  }

  const handleConfirm = () => {
    state.value.resolve?.(true)
    state.value.isOpen = false
  }

  const handleCancel = () => {
    state.value.resolve?.(false)
    state.value.isOpen = false
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      handleCancel()
    }
  }

  return {
    state,
    showConfirm,
    handleConfirm,
    handleCancel,
    handleOpenChange,
  }
}
